import { useTrackFormTouched } from 'hooks/tracking';

type FormTrackerProps = {
  formType: string;
};

const FormTracker = ({ formType }: FormTrackerProps) => {
  useTrackFormTouched(formType);
  return null;
};

export default FormTracker;
